module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_dress-5dc254e7db0c7cc66c2322cfb06e7ff5.webp";